import classNames from 'classnames'
import { uniqueId } from 'lodash'
import React from 'react'
import useIsMobile from '../../modules/hooks/common/useIsMobile'
import LinkLocale from '../../modules/i18n/LinkLocale'
import { ICON_CHEVRON_RIGHT_GRAY, ICON_QUESTION_BLACK } from '../../modules/svg/svg'
import TooltipNew from '../_legacy/TooltipNew'

interface TitleSectionProps {
  title?: string | React.ReactElement
  badge?: React.ReactElement
  subtitle?: string
  seeAll?: string
  allLink?: string
  rightSideTitle?: string
  marginB?: boolean
  tooltip?: boolean
  subTitleClassName?: string
  linkTitleClassName?: string
  linkImageClassName?: string
}

const TitleSection = ({
  title,
  badge,
  subtitle,
  seeAll,
  allLink,
  marginB,
  rightSideTitle,
  tooltip,
  subTitleClassName = 'text-gray-500 text-sBody',
  linkTitleClassName = 'inline font-medium text-gray-500 text-h5',
  linkImageClassName = 'ml-[12px] inline align-baseline',
}: TitleSectionProps) => {
  const isMobile = useIsMobile()
  const tooltipId = uniqueId('tooltip-')

  return (
    <div
      style={{ marginBottom: `${marginB}px` }}
      className={classNames({ 'mb-[16px]': !marginB }, isMobile ? 'flex-col' : 'flex-row justify-between', 'flex')}
    >
      <div className={classNames(isMobile && seeAll && 'mb-16')}>
        <div className="text-h2 flex items-center font-bold">
          {title}
          {badge}
          {tooltip && (
            <>
              <img src={ICON_QUESTION_BLACK} className="mt-[4px] ml-[4px]" alt=" " />
              <TooltipNew
                id={tooltipId}
                clickable
                tooltipBgClx="bg-white"
                tooltipClx="shadow-lg pointer-events-auto border-1 border-gray-100"
              >
                {tooltip}
              </TooltipNew>
            </>
          )}
        </div>
        <span className={subTitleClassName}>{subtitle}</span>
      </div>
      {rightSideTitle && <div className="flex items-end text-[16px] text-gray-500">{rightSideTitle}</div>}
      {seeAll && allLink && (
        <LinkLocale href={allLink} className="self-end">
          <span className={linkTitleClassName}>
            {seeAll}
            <img src={ICON_CHEVRON_RIGHT_GRAY} className={linkImageClassName} />
          </span>
        </LinkLocale>
      )}
    </div>
  )
}

export default TitleSection
